export const CUSTOM_CONFIG_BASED = 'Custom - configurator based';
export const CUSTOM_WITH_STOCK = 'Custom with stock';
export const CUSTOM_PRICE_VSO = 'Custom - Starting Price & Virtual Assist Only';
